module.exports = _.isEqual;